import { CheckCircle, ExternalLink, AlertCircle, Loader2 } from "lucide-react";

export default function BrowserAgentPreview({ feedback = [] }) {
    const session = feedback.find((f) => f.type === "browser_agent_session");
    const steps = feedback.filter((f) => f.type === "browser_agent_step");
    const completion = feedback.find((f) => f.type === "browser_agent_complete");
    const error = feedback.find((f) => f.type === "browser_agent_error");

    if (!session) return null;

    const isRunning = !completion && !error;

    return (
        <div className="bg-gray-50 rounded-lg border p-3 max-w-md">
            <div className="relative aspect-video bg-gray-900 rounded overflow-hidden mb-2">
                <iframe
                    src={session.sessionInfo?.debuggerFullscreenUrl || session.sessionInfo?.debugUrl}
                    className="w-full h-full"
                    title="Browser Agent Preview"
                />
                <a
                    href={session.sessionInfo?.debuggerFullscreenUrl || session.sessionInfo?.debugUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="absolute top-2 right-2 bg-white/90 px-2 py-1 rounded text-xs flex items-center gap-1 hover:bg-white"
                >
                    <ExternalLink className="h-3 w-3" /> Fullscreen
                </a>
                {isRunning && (
                    <div className="absolute bottom-2 left-2 bg-blue-500/90 text-white px-2 py-1 rounded text-xs flex items-center gap-1">
                        <Loader2 className="h-3 w-3 animate-spin" /> Running...
                    </div>
                )}
            </div>

            {steps.length > 0 && (
                <div className="space-y-1 max-h-32 overflow-y-auto">
                    {steps.map((s, i) => (
                        <div key={i} className="text-xs flex items-center gap-2">
                            <CheckCircle className="h-3 w-3 text-green-500 shrink-0" />
                            <span className="truncate">
                                {s.step?.action || `Step ${s.step?.number}`}
                            </span>
                        </div>
                    ))}
                </div>
            )}

            {completion && (
                <div
                    className={`mt-2 p-2 rounded text-sm ${
                        completion.result?.success ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                    }`}
                >
                    {completion.result?.message || "Completed"}
                </div>
            )}

            {error && (
                <div className="mt-2 p-2 rounded text-sm bg-red-100 text-red-800 flex items-center gap-2">
                    <AlertCircle className="h-4 w-4 text-red-500 shrink-0" />
                    {error.error?.message || "An error occurred"}
                </div>
            )}
        </div>
    );
}
